<template>
  <div>
    <CreateRecord
      v-if="createRecordModal"
      :show="createRecordModal"
      v-on:closeRecordModal="createRecordModal = false"
      v-on:recordCreated="addNewRecord"
    />
    <div class="page-wrapper">
      <loading
        :active.sync="isLoading"
        :is-full-page="fullPage"
        background-color="#f3f3f3"
        :opacity="0.8"
        loader="bars"
      ></loading>
      <button
        class="btn btn-primary introjs m-2 mr-4 pt-1"
        @click="startIntroJs"
      >
        Tour<i class="font-16 text-warning ml-2 mdi mdi-lightbulb-on"></i>
      </button>
      <div class="page-breadcrumb">
        <div class="row">
          <div class="col-md-5 align-self-center mb-2">
            <h6 class="page-title">{{ $t("all-records") }}</h6>
            <h6 class="text-muted">
              {{ $t("schedule_reading") }}
            </h6>
          </div>
          <div class="col-md-7 align-self-center">
            <div class="d-flex align-items-center justify-content-end">
              <!-- <button @click="downloadpdf" class="btn btn-secondary">
                Export to PDF
              </button> -->
              <button
                data-step="1"
                data-intro="<h5 style='margin-bottom: 1rem; color: #213e7a'>Users</h5>Assign members of your team to monitor selected devices."
                @click="openModal"
                class="btn btn-primary"
              >
                {{ $t("add_new_record") }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid">
        <div
          v-if="mssg"
          align="center"
          class="alert alert-success alert-dismissible fade show text-center margin-bottom-1x"
        >
          <p class="alert-close mb-0">
            {{ mssg }}
          </p>
        </div>
        <div
          v-else-if="Errormssg"
          align="center"
          class="alert alert-danger alert-dismissible fade show text-center margin-bottom-1x"
        >
          <p class="alert-close mb-0">
            {{ Errormssg }}
          </p>
        </div>
        <div class="card" style="max-height: 23rem; overflow-y: auto">
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <div ref="content" class="table-responsive">
                  <table id="order-listing" class="table table-hover display">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>{{ $t("name") }}</th>
                        <th>{{ $t("device") }}</th>
                        <th>{{ $t("start") }}</th>
                        <th>{{ $t("end") }}</th>
                        <th>{{ $t("date_created") }}</th>
                        <th>{{ $t("acts") }}</th>
                      </tr>
                    </thead>
                    <tbody v-if="records.length !== 0">
                      <tr
                        :key="index"
                        v-for="(record, index) in records"
                        class="record-row"
                      >
                        <td
                          class="cursor-pointer"
                          @click="viewrecord(record._id)"
                        >
                          {{ records.indexOf(record) + 1 }}
                        </td>
                        <td
                          class="cursor-pointer"
                          @click="viewrecord(record._id)"
                        >
                          {{ record.name }}
                        </td>
                        <td
                          class="cursor-pointer"
                          @click="viewrecord(record._id)"
                        >
                          {{ record.device }}
                        </td>
                        <td
                          class="cursor-pointer"
                          @click="viewrecord(record._id)"
                        >
                          <div v-if="record.startTime">
                            {{ getDate(record.startTime) }}
                          </div>
                          <div v-else>{{ $t("waiting") }}</div>
                        </td>
                        <td
                          class="cursor-pointer"
                          @click="viewrecord(record._id)"
                        >
                          <div v-if="record.endTime">
                            {{ getDate(record.endTime) }}
                          </div>
                          <div v-else>{{ $t("waiting") }}</div>
                        </td>
                        <td
                          class="cursor-pointer"
                          @click="viewrecord(record._id)"
                        >
                          {{ getDate(record.createdAt) }}
                        </td>
                        <td>
                          <div class="d-flex">
                            <div
                              :class="{ 'inactive-icon': record.startTime }"
                              @click="startrecord(record._id)"
                              class="mr-3 cursor-pointer"
                            >
                              <IconPlay />
                            </div>
                            <div
                              :class="{
                                'inactive-icon':
                                  record.endTime || !record.startTime,
                              }"
                              @click="endrecord(record._id)"
                              class="cursor-pointer"
                            >
                              <IconStop />
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else align="center">
                      <tr align="center">
                        <td colspan="7">
                          {{ $t("no_record_yet") }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer class="footer text-center">&#169;{{ new Date().getFullYear() }} {{ $t("all-rights") }}</footer>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import CreateRecord from "../Modals/CreateRecord";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import store from "../../store/index";
import introJs from "intro.js";
import "intro.js/introjs.css";
import moment from "moment";
import IconPlay from "../../components/Iconsvg/IconPlay";
import IconStop from "../../components/Iconsvg/IconStop";

export default {
  name: "Records",
  components: {
    CreateRecord,
    Loading,
    IconPlay,
    IconStop,
  },
  data() {
    return {
      isLoading: true,
      fullPage: true,
      mssg: "",
      Errormssg: "",
      createRecordModal: false,
    };
  },
  mounted() {
    this.getRecords().then(() => {
      this.isLoading = false;
    });
  },
  beforeRouteEnter(to, from, next) {
    // Checks if the user is a staff
    if (store.getters.profile.role === "staff") {
      next(from);
    } else {
      next();
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name !== "Dispatch") {
      this.$emit("hideRecords");
    }
    next();
  },
  computed: {
    ...mapGetters(["records", "profile"]),
  },
  methods: {
    ...mapActions(["getRecords", "addRecord", "endRecord", "startRecord"]),

    startIntroJs() {
      introJs().start();
    },
    openModal() {
      this.createRecordModal = true;
      introJs().exit();
    },
    viewrecord(id) {
      this.$router.push(`records/${id}`);
    },
    addNewRecord(record) {
      this.records.unshift(record);
      this.createRecordModal = false;
    },
    getDate(date) {
      return moment(date, "x", true).format("ddd, MMM Do YYYY, hh:mm a");
    },
    startrecord(id) {
      this.isLoading = true;
      this.startRecord(id)
        .then((res) => {
          if (res.data.status === "success") {
            this.mssg =
              res.data.message[0].toUpperCase() + res.data.message.slice(1);
            this.getRecords().then(() => {
              this.mssg = "";
              this.isLoading = false;
            });
          }
        })
        .catch((error) => {
          this.isLoading = false;
          this.Errormssg =
            error.response.data.message[0].toUpperCase() +
            error.response.data.message.slice(1);
          // error.response can be null
          if (error.response) {
            console.error(error.response.data.message);
          }
        });
    },
    endrecord(id) {
      this.isLoading = true;
      this.endRecord(id)
        .then((res) => {
          if (res.data.status === "success") {
            this.mssg =
              res.data.message[0].toUpperCase() + res.data.message.slice(1);
            this.getRecords().then(() => {
              this.mssg = "";
              this.isLoading = false;
            });
          }
        })
        .catch((error) => {
          this.isLoading = false;
          this.Errormssg =
            error.response.data.message[0].toUpperCase() +
            error.response.data.message.slice(1);
          // error.response can be null
          if (error.response) {
            console.error(error.response.data.message);
          }
        });
    },
  },
};
</script>

<style>
.inactive-icon svg path {
  stroke: #213e7a;
}
</style>
<style scoped>
.inactive-icon {
  pointer-events: none;
}
.introjs {
  position: fixed;
  top: 0.3rem;
  right: 12rem;
  z-index: 60;
}
@media (max-width: 991px) {
  .introjs {
    display: none !important;
  }
}
td {
  border-bottom: 1px rgba(0, 0, 0, 0.1) solid;
}
th,
td {
  min-width: 150px;
}
th.active {
  color: #fff;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.flex {
  display: flex;
}
</style>

<i18n>
{
	"en": {
		"acts": "Actions (Start/End Record)",
		"add_new_record": "Add New Record",
		"all-records": "All Records",
		"date_created": "Date Created",
		"device": "Device",
		"end": "End",
		"name": "Name",
		"no_record_yet": "You have no records yet",
		"schedule_reading": "Schedule your readings",
		"start": "Start",
		"waiting": "Waiting"
	},
	"es": {
		"acts": "Acciones (Iniciar / Finalizar registro)",
		"add_new_record": "Añadir nuevo registro",
		"all-records": "Todos los registros",
		"date_created": "Fecha de creacion",
		"device": "Dispositivo",
		"end": "Fin",
		"name": "Nombre",
		"no_record_yet": "Aún no tienes registros",
		"schedule_reading": "Programe sus lecturas",
		"start": "comienzo",
		"waiting": "Esperando"
	},
	"fr": {
		"acts": "Actions (enregistrement de début/fin)",
		"add_new_record": "Ajouter un nouvel enregistrement",
		"all-records": "Tous les enregistrements",
		"date_created": "Date créée",
		"device": "Dispositif",
		"end": "Fin",
		"name": "Prénom",
		"no_record_yet": "Vous n'avez pas encore d'enregistrements",
		"schedule_reading": "Programmez vos lectures",
		"start": "Début",
		"waiting": "Attendre"
	},
	"sw": {
		"acts": "Vitendo (Anza/Mwisho Rekodi)",
		"add_new_record": "Ongeza Rekodi Mpya",
		"all-records": "Rekodi Zote",
		"date_created": "Tarehe Iliyoundwa",
		"device": "Kifaa",
		"end": "Mwisho",
		"name": "Jina",
		"no_record_yet": "Bado huna rekodi",
		"schedule_reading": "Panga usomaji wako",
		"start": "Anza",
		"waiting": "Kusubiri"
	}
}
</i18n>
